import React from "react";

const LazyMeetingParticipants = React.lazy(() =>
  import("./MeetingParticipants").then((module) => ({ default: module.MeetingParticipants }))
);

export default LazyMeetingParticipants;
